import React from 'react';
import useTranslation from '../../../Hooks/useTranslation';
//@ts-ignore
import styles from './DataTable.module.scss';

interface IRow {
	label: string;
	value: string | number | React.ReactNode;
	isNested?: boolean;
	children?: React.ReactNode;
}

const Row: React.FC<IRow> = ({ label, value, isNested, children }) => {
	const { t } = useTranslation();

	return (
		<tr key={label} className={isNested ? styles.nestedRow : styles.row}>
			<td className={styles.dataWrapper}>
				<div className={styles.cell}>{t(label)}</div>
				<div className={styles.cell}>{value}</div>
			</td>
			<td>{children}</td>
		</tr>
	);
};

type TableDotNotationType = { Row?: React.FC<IRow> };

interface Props {
	children: React.ReactNode;
}

const DataTable: React.FC<Props> & TableDotNotationType = ({ children }) => (
	<table className={styles.tableWrapper}>
		<thead />
		<tbody>{children}</tbody>
	</table>
);

DataTable.Row = Row;

export default DataTable;
